import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { Route } from '../types';

export function useRoute(routeId: string | null) {
  return useQuery({
    queryKey: queryKeys.routes.detail(routeId ?? ''),
    queryFn: () => apiClient.get<Route>(`/routes/${routeId}`),
    enabled: !!routeId,
  });
}
